import {
  authorizeGetRequest,
  authorizePutRequest,
} from "api";
import { IApiResponse, IPaginatedResponse } from "models";
import {
  IPassengerWallet,
  IPassengerWalletDetailResponse,
  IUpdatePassengerWalletBalance,
} from "models/passengerWallet";

export const passengerWalletsApi = (
  page: number,
  perPage: number,
  search: string,
  useCache: boolean = false
) => {
  search = search.replace("+", "%2B");
  return authorizeGetRequest<IPaginatedResponse<IPassengerWallet>>(
    `passenger-wallets?page=${page}&per_page=${perPage}&search=${search}`,
    useCache
  );
};

export const fetchPassengerWalletDetailApi = (
  id: string,
  page: number,
  perPage: number
) => {
  return authorizeGetRequest<IPassengerWalletDetailResponse>(
    `passenger-wallets/${id}/detail?page=${page}&per_page=${perPage}`
  );
};

export const fetchPassengerWalletDetailByPassengerIdApi = (
  id: string,
  page: number,
  perPage: number
) => {
  return authorizeGetRequest<IPassengerWalletDetailResponse>(
    `passenger-wallets/passenger/${id}/detail?page=${page}&per_page=${perPage}`
  );
};

export const topUpPassengerWalletApi = (
  id: string,
  data: IUpdatePassengerWalletBalance
) => {
  return authorizePutRequest<IApiResponse<IPassengerWallet>>(
    `passenger-wallets/${id}/balance/add`,
    data
  );
};

export const deductPassengerWalletApi = (
  id: string,
  data: IUpdatePassengerWalletBalance
) => {
  return authorizePutRequest<IApiResponse<IPassengerWallet>>(
    `passenger-wallets/${id}/balance/deduct`,
    data
  );
};
